import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import ListView from './AvailableSlots/ListView';
import TableView from './AvailableSlots/TableView';

interface TimeSlotSelectionProps {
  selectedSlot: string | null;
  onSlotSelect: (slotId: string) => void;
  slotsByDate?: Record<string, Record<string, string[]>>;
  onPrevWeek?: () => void;
  onNextWeek?: () => void;
  currentStart: Date;
  onOperatoriesSelect?: (operatories: string[]) => void;
  daysToShow?: number;
  viewMode?: 'table' | 'list'; // Add view mode prop
}

const TimeSlotSelection = ({
  selectedSlot,
  onSlotSelect,
  slotsByDate,
  onPrevWeek,
  onNextWeek,
  currentStart,
  onOperatoriesSelect,
  daysToShow = 7,
  viewMode,
}: TimeSlotSelectionProps) => {
  const { treatment } = useSelector((s: RootState) => s.appointment);

  const getVisibleDates = () => {
    const dates: Date[] = [];
    for (let i = 0; i < daysToShow; i++) {
      const d = new Date(currentStart);
      d.setDate(currentStart.getDate() + i);
      dates.push(d);
    }
    return dates;
  };
  const visibleDates = getVisibleDates();

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
  };

  const bufferMinutes = treatment?.bufferMinutes || 0;

  const commonProps = {
    visibleDates,
    slotsByDate,
    selectedSlot,
    onSlotSelect,
    onOperatoriesSelect,
    bufferMinutes,
  };

  return (
    <div className="space-y-4">
      <div className="">
        {/* Sticky Header - Same for both views */}
        <div className="flex items-center justify-between mb-4">
          <button
            onClick={onPrevWeek}
            className="flex items-center px-3 py-1 text-sm text-gray-600 hover:text-teamcare-yellow disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            <ChevronLeft />
          </button>

          <h3 className="text-xs sm:text-sm font-semibold text-gray-900">
            {`${formatDate(visibleDates[0])} - ${formatDate(visibleDates[visibleDates.length - 1])}`}
          </h3>

          <button
            onClick={onNextWeek}
            className="flex items-center px-3 py-1 text-sm text-gray-600 hover:text-teamcare-yellow disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            <ChevronRight />
          </button>
        </div>

        {/* Table View */}
        {viewMode === 'table' && <TableView {...commonProps} daysToShow={daysToShow} />}

        {/* List View */}
        {viewMode === 'list' && <ListView {...commonProps} />}
      </div>
    </div>
  );
};

export default TimeSlotSelection;